import React from 'react';
import { useTranslation } from 'react-i18next';
import { GridContainer } from 'shared/components/ui/grid-container';
import { SearchInput } from 'shared/components/ui/search-input';

import * as Styled from './template-search.style';

export type TemplateSearchProps = {
  onChange: (search: string) => void;
  initialValue: string;
};

export const TemplateSearch: React.FC<TemplateSearchProps> = ({
  onChange,
  initialValue,
}) => {
  const { t } = useTranslation();

  return (
    <GridContainer>
      <Styled.Container>
        <SearchInput
          value={initialValue}
          onChange={onChange}
          placeholder={t('pages.goal-templates.search.placeholder.label')}
          isAlternative
          preventDrag
        />
      </Styled.Container>
    </GridContainer>
  );
};
